@if ((loading$ | async) === true) {
  <div class="spinner m-auto mt-40 h-32 w-32 border-8"></div>
} @else if ((loading$ | async) === false) {
  <div class="w-full overflow-auto">
    <ag-grid-angular
      domLayout="autoHeight"
      class="ag-theme-aux compare-grid tabular-nums"
      [gridOptions]="(gridOptions$ | async)!"
      [autoGroupColumnDef]="autoGroupColumnDef"
      [columnDefs]="columnDefs"
      [rowData]="gridData$ | async"
      [groupAllowUnbalanced]="true"
      (firstDataRendered)="onDataRendered($event); autoSize()"
      (filterChanged)="onFilterChanged()"
      auxStickyGrid
    />
  </div>
}
